import { ACTIONS } from 'actions/av/av-session-token';

const initialState = {};

const DEFAULTS = {
  loading: false,
};

const getMergedState = (state, teacherClassroomId, data) => {
  return {
    [teacherClassroomId]: {
      ...DEFAULTS,
      ...state[teacherClassroomId],
      ...data,
    },
  };
};

export const getAVSessionTokenState = (state, teacherClassroomId) => {
  return state[teacherClassroomId] ?? DEFAULTS;
};

const avSessionTokenReducer = (state = initialState, action) => {
  const { type } = action;

  if (type === ACTIONS.SET_AV_SESSION_TOKEN_LOADING) {
    const { teacherClassroomId } = action.payload;

    return getMergedState(state, teacherClassroomId, {
      sessionId: undefined,
      authToken: undefined,
      loading: true,
    });
  }

  if (type === ACTIONS.SET_AV_SESSION_TOKEN) {
    const { teacherClassroomId } = action.payload;

    return getMergedState(state, teacherClassroomId, {
      loading: false,
      sessionId: action.payload.sessionId,
      authToken: action.payload.authToken,
    });
  }

  if (type === ACTIONS.RESET_AV_SESSION_TOKEN) {
    return initialState;
  }

  return state;
};

export default avSessionTokenReducer;
